import { useMemo } from 'react';
import { filterEmptyHint, type FilterAxis } from '@voll-intelligence/intelligence-ui-kit';
import { flightExplorerCopy } from '../../shared/ui/flight_explorer_copy.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';

/** A dica do vazio-por-filtro do kit (#4997) com os textos do catálogo: nomeia
 *  os eixos que estão cortando, com os rótulos do painel. */
export function useFilterEmptyHint(axes: readonly FilterAxis[]): string {
  const { locale } = useGenUiI18n();
  const copy = useMemo(() => flightExplorerCopy(locale), [locale]);
  return filterEmptyHint(axes, copy.page, copy.filter);
}
